import React, { useEffect, useState } from "react";
import { userApi } from "../../api/auctiongate.js";

export default function LocationInfo() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    userApi.location().then(
      (r) => !cancelled && setData(r),
      (e) => !cancelled && setErr(e?.message || "Failed to load geo")
    );
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="card">
      <div className="card__title">
        IP & Location
        <span className="badge">ipapi.co</span>
      </div>
      {err && <div className="login-error">{err}</div>}
      {!data && !err && <span className="loader" />}
      {data && (
        <dl className="kv">
          <dt>IP</dt>
          <dd style={{ fontFamily: "monospace" }}>{data.ip ?? "—"}</dd>
          <dt>Country</dt>
          <dd>{data.country_name ?? data.country ?? "—"}</dd>
          <dt>Region / City</dt>
          <dd>
            {[data.region, data.city].filter(Boolean).join(", ") || "—"}
          </dd>
          <dt>ISP</dt>
          <dd>{data.org ?? data.asn ?? "—"}</dd>
          <dt>Timezone</dt>
          <dd>{data.timezone ?? "—"}</dd>
        </dl>
      )}
    </div>
  );
}
